import React, { useMemo, useState } from "react";
import {
    Search,
    UserRound,
    MapPin,
    Phone,
    Download,
    Eye,
    Heart,
    X,
    CheckCircle,
    Crown,
    CalendarDays,
    BriefcaseBusiness,
    GraduationCap,
    Users,
    CreditCard,
    AlertCircle,
    ArrowLeft,
    Sparkles,
} from "lucide-react";

const members = [
    {
        memberId: "JP00045",
        name: "Meena",
        gender: "Female",
        age: 27,
        dob: "12-06-1999",
        mobile: "9876543210",
        address: "Erode, Tamil Nadu",
        city: "Erode",
        district: "Erode",
        state: "Tamil Nadu",
        community: "Community A",
        subCommunity: "Sub Community A",
        caste: "Caste A",
        religion: "Hindu",
        motherTongue: "Tamil",
        education: "B.E Computer Science",
        profession: "Software Engineer",
        company: "ABC Technologies",
        designation: "Software Developer",
        income: "₹6,00,000",
        height: "5.4",
        complexion: "Fair",
        maritalStatus: "Never Married",
        star: "Anusham",
        rasi: "Viruchigam",
        dosham: "No Dosham",
        photo:
            "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600",
        subscription: {
            active: true,
            plan: "Premium",
            profileViews: 12,
            profileDownloads: 5,
        },
    },
    {
        memberId: "JP00072",
        name: "Priya",
        gender: "Female",
        age: 26,
        dob: "25-03-2000",
        mobile: "9876501234",
        address: "Coimbatore, Tamil Nadu",
        city: "Coimbatore",
        district: "Coimbatore",
        state: "Tamil Nadu",
        community: "Community A",
        subCommunity: "Sub Community B",
        caste: "Caste B",
        religion: "Hindu",
        motherTongue: "Tamil",
        education: "M.Com",
        profession: "Accounts Executive",
        company: "XYZ Pvt Ltd",
        designation: "Senior Executive",
        income: "₹4,80,000",
        height: "5.3",
        complexion: "Wheatish",
        maritalStatus: "Never Married",
        star: "Rohini",
        rasi: "Rishabam",
        dosham: "No Dosham",
        photo:
            "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=600",
        subscription: {
            active: true,
            plan: "Basic",
            profileViews: 4,
            profileDownloads: 2,
        },
    },
    {
        memberId: "JP00105",
        name: "Kavya",
        gender: "Female",
        age: 28,
        dob: "09-11-1998",
        mobile: "9988776655",
        address: "Salem, Tamil Nadu",
        city: "Salem",
        district: "Salem",
        state: "Tamil Nadu",
        community: "Community B",
        subCommunity: "Sub Community C",
        caste: "Caste C",
        religion: "Hindu",
        motherTongue: "Tamil",
        education: "MBA",
        profession: "HR Manager",
        company: "PQR Industries",
        designation: "HR Manager",
        income: "₹7,20,000",
        height: "5.5",
        complexion: "Fair",
        maritalStatus: "Never Married",
        star: "Revathi",
        rasi: "Meenam",
        dosham: "No Dosham",
        photo:
            "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=600",
        subscription: {
            active: false,
            plan: "",
            profileViews: 0,
            profileDownloads: 0,
        },
    },
];

function Matches() {
    const [search, setSearch] = useState("");
    const [searchedMember, setSearchedMember] = useState(null);
    const [matchedProfiles, setMatchedProfiles] = useState([]);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [showSubscribeModal, setShowSubscribeModal] = useState(false);
    const [showLimitModal, setShowLimitModal] = useState(false);
    const [limitType, setLimitType] = useState("");
    const [activeTab, setActiveTab] = useState("all");

    const handleSearch = () => {
        const value = search.trim().toLowerCase();

        if (!value) {
            setSearchedMember(null);
            setMatchedProfiles([]);
            return;
        }

        const member = {
            memberId: "JP00031",
            name: "Arun Kumar",
            gender: "Male",
            age: 30,
            mobile: "9876543210",
            address: "Erode, Tamil Nadu",
            subscription: {
                active: true,
                plan: "Gold",
                profileViews: 8,
                profileDownloads: 3,
            },
        };

        const matched = members.filter((item) => {
            if (item.gender === "Female") {
                return true;
            }

            return false;
        });

        setSearchedMember(member);
        setMatchedProfiles(matched);
    };

    const filteredProfiles = useMemo(() => {
        if (activeTab === "subscribed") {
            return matchedProfiles.filter(
                (item) => item.subscription.active
            );
        }

        if (activeTab === "available") {
            return matchedProfiles.filter(
                (item) =>
                    item.subscription.active &&
                    item.subscription.profileViews > 0
            );
        }

        return matchedProfiles;
    }, [matchedProfiles, activeTab]);

    const openProfile = (profile) => {
        if (!searchedMember?.subscription?.active) {
            setShowSubscribeModal(true);
            return;
        }

        if (searchedMember.subscription.profileViews <= 0) {
            setLimitType("view");
            setShowLimitModal(true);
            return;
        }

        const updatedMember = {
            ...searchedMember,
            subscription: {
                ...searchedMember.subscription,
                profileViews:
                    searchedMember.subscription.profileViews - 1,
            },
        };

        setSearchedMember(updatedMember);
        setSelectedProfile(profile);
    };

    const downloadProfile = (profile) => {
        if (!searchedMember?.subscription?.active) {
            setShowSubscribeModal(true);
            return;
        }

        if (searchedMember.subscription.profileDownloads <= 0) {
            setLimitType("download");
            setShowLimitModal(true);
            return;
        }

        const updatedMember = {
            ...searchedMember,
            subscription: {
                ...searchedMember.subscription,
                profileDownloads:
                    searchedMember.subscription.profileDownloads - 1,
            },
        };

        setSearchedMember(updatedMember);

        alert(
            `${profile.name}'s profile download started. Remaining downloads: ${updatedMember.subscription.profileDownloads}`
        );
    };

    const closeProfile = () => {
        setSelectedProfile(null);
    };

    return (
        <div className="branch-matches-page">

            {/* HEADER */}
            <div className="matches-page-header">

                <div>
                    <div className="matches-title-row">
                        <div className="matches-title-icon">
                            <Heart size={24} />
                        </div>

                        <div>
                            <h1>Matches</h1>
                            <p>
                                Search members and find suitable matrimonial
                                profiles
                            </p>
                        </div>
                    </div>
                </div>

            </div>

            {/* SEARCH CARD */}
            <div className="match-search-card">

                <div className="match-search-heading">
                    <div className="match-search-icon">
                        <Search size={21} />
                    </div>

                    <div>
                        <h3>Find Matches</h3>
                        <p>
                            Search using Member ID or Mobile Number
                        </p>
                    </div>
                </div>

                <div className="match-search-box">

                    <Search size={19} />

                    <input
                        type="text"
                        placeholder="Enter Member ID or Mobile Number..."
                        value={search}
                        onChange={(e) =>
                            setSearch(e.target.value)
                        }
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleSearch();
                            }
                        }}
                    />

                    {search && (
                        <button
                            className="clear-search"
                            onClick={() => {
                                setSearch("");
                                setSearchedMember(null);
                                setMatchedProfiles([]);
                            }}
                        >
                            <X size={16} />
                        </button>
                    )}

                    <button
                        className="find-match-btn"
                        onClick={handleSearch}
                    >
                        Find Matches
                    </button>

                </div>

                <div className="search-help">
                    Example: <strong>JP00031</strong> or{" "}
                    <strong>9876543210</strong>
                </div>

            </div>

            {/* SEARCHED MEMBER */}
            {searchedMember && (
                <div className="searched-member-card">

                    <div className="searched-member-left">

                        <div className="searched-avatar">
                            {searchedMember.name.charAt(0)}
                        </div>

                        <div>
                            <div className="searched-member-name">
                                {searchedMember.name}

                                <span className="member-id-badge">
                                    {searchedMember.memberId}
                                </span>
                            </div>

                            <div className="searched-member-details">
                                <span>
                                    <Phone size={13} />
                                    {searchedMember.mobile}
                                </span>

                                <span>
                                    <MapPin size={13} />
                                    {searchedMember.address}
                                </span>

                                <span>
                                    <UserRound size={13} />
                                    {searchedMember.age} Years
                                </span>
                            </div>
                        </div>

                    </div>

                    {/* SUBSCRIPTION */}
                    {searchedMember.subscription.active ? (
                        <div className="member-subscription-box">

                            <div className="subscription-plan">
                                <Crown size={16} />
                                {searchedMember.subscription.plan}
                            </div>

                            <div className="subscription-counts">

                                <div>
                                    <strong>
                                        {
                                            searchedMember
                                                .subscription
                                                .profileViews
                                        }
                                    </strong>
                                    <span>Views Left</span>
                                </div>

                                <div>
                                    <strong>
                                        {
                                            searchedMember
                                                .subscription
                                                .profileDownloads
                                        }
                                    </strong>
                                    <span>Downloads Left</span>
                                </div>

                            </div>

                        </div>
                    ) : (
                        <button
                            className="subscribe-warning-btn"
                            onClick={() =>
                                setShowSubscribeModal(true)
                            }
                        >
                            <CreditCard size={16} />
                            Please Subscribe
                        </button>
                    )}

                </div>
            )}

            {/* RESULTS */}
            {searchedMember && (
                <div className="match-results-section">

                    <div className="results-header">

                        <div>
                            <h2>Matched Profiles</h2>
                            <p>
                                {matchedProfiles.length} suitable profiles
                                found for {searchedMember.name}
                            </p>
                        </div>

                        <div className="results-tabs">

                            <button
                                className={
                                    activeTab === "all"
                                        ? "active"
                                        : ""
                                }
                                onClick={() =>
                                    setActiveTab("all")
                                }
                            >
                                All Profiles
                            </button>

                            <button
                                className={
                                    activeTab === "subscribed"
                                        ? "active"
                                        : ""
                                }
                                onClick={() =>
                                    setActiveTab("subscribed")
                                }
                            >
                                Subscribed
                            </button>

                            <button
                                className={
                                    activeTab === "available"
                                        ? "active"
                                        : ""
                                }
                                onClick={() =>
                                    setActiveTab("available")
                                }
                            >
                                Available Views
                            </button>

                        </div>

                    </div>

                    {/* PROFILE LIST */}
                    <div className="matched-profile-list">

                        {filteredProfiles.map((profile) => (
                            <div
                                className="matched-profile-card"
                                key={profile.memberId}
                            >

                                {/* IMAGE */}
                                <div className="matched-profile-image">
                                    <img
                                        src={profile.photo}
                                        alt={profile.name}
                                    />

                                    <span className="match-score">
                                        <Sparkles size={12} />
                                        92% Match
                                    </span>
                                </div>

                                {/* INFO */}
                                <div className="matched-profile-info">

                                    <div className="profile-name-row">
                                        <h3>
                                            {profile.name}
                                        </h3>

                                        <span className="profile-member-id">
                                            {profile.memberId}
                                        </span>
                                    </div>

                                    <div className="profile-basic-info">

                                        <span>
                                            {profile.age} Years
                                        </span>

                                        <span>
                                            {profile.height} ft
                                        </span>

                                        <span>
                                            {profile.maritalStatus}
                                        </span>

                                    </div>

                                    <div className="profile-detail-grid">

                                        <div>
                                            <GraduationCap size={15} />
                                            <span>
                                                {profile.education}
                                            </span>
                                        </div>

                                        <div>
                                            <BriefcaseBusiness
                                                size={15}
                                            />
                                            <span>
                                                {profile.profession}
                                            </span>
                                        </div>

                                        <div>
                                            <Users size={15} />
                                            <span>
                                                {profile.community}
                                            </span>
                                        </div>

                                        <div>
                                            <MapPin size={15} />
                                            <span>
                                                {profile.address}
                                            </span>
                                        </div>

                                    </div>

                                </div>

                                {/* ACTIONS */}
                                <div className="matched-profile-actions">

                                    {profile.subscription.active ? (
                                        <div className="profile-plan-status">
                                            <CheckCircle size={14} />
                                            {profile.subscription.plan}
                                        </div>
                                    ) : (
                                        <div className="profile-no-plan">
                                            Subscription Required
                                        </div>
                                    )}

                                    <button
                                        className="view-profile-btn"
                                        onClick={() =>
                                            openProfile(profile)
                                        }
                                    >
                                        <Eye size={16} />
                                        View Profile
                                    </button>

                                    <button
                                        className="download-profile-btn"
                                        onClick={() =>
                                            downloadProfile(profile)
                                        }
                                    >
                                        <Download size={16} />
                                        Download
                                    </button>

                                </div>

                            </div>
                        ))}

                    </div>

                    {filteredProfiles.length === 0 && (
                        <div className="no-match-results">
                            <Users size={45} />

                            <h3>
                                No Matching Profiles
                            </h3>

                            <p>
                                No profiles are available for the
                                selected filter.
                            </p>
                        </div>
                    )}

                </div>
            )}

            {/* INITIAL STATE */}
            {!searchedMember && (
                <div className="matches-empty-state">

                    <div className="empty-match-icon">
                        <Search size={42} />
                    </div>

                    <h2>Search for a Member</h2>

                    <p>
                        Enter a Member ID or mobile number above to
                        find suitable matrimonial matches.
                    </p>

                    <div className="empty-search-example">
                        <span>Member ID</span>
                        <strong>JP00031</strong>

                        <span>or</span>

                        <span>Mobile</span>
                        <strong>9876543210</strong>
                    </div>

                </div>
            )}

            {/* FULL PROFILE MODAL */}
            {selectedProfile && (
                <div
                    className="match-modal-overlay"
                    onClick={closeProfile}
                >
                    <div
                        className="full-profile-modal"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        <div className="full-profile-header">

                            <div>
                                <button
                                    className="modal-back-btn"
                                    onClick={closeProfile}
                                >
                                    <ArrowLeft size={17} />
                                    Back
                                </button>
                            </div>

                            <button
                                className="modal-close-btn"
                                onClick={closeProfile}
                            >
                                <X size={20} />
                            </button>

                        </div>

                        <div className="full-profile-content">

                            <div className="full-profile-top">

                                <img
                                    src={
                                        selectedProfile.photo
                                    }
                                    alt={
                                        selectedProfile.name
                                    }
                                />

                                <div className="full-profile-main">

                                    <div className="full-name-line">
                                        <h2>
                                            {
                                                selectedProfile.name
                                            }
                                        </h2>

                                        <span>
                                            {
                                                selectedProfile.memberId
                                            }
                                        </span>
                                    </div>

                                    <p>
                                        {
                                            selectedProfile.age
                                        } Years •{" "}
                                        {
                                            selectedProfile
                                                .education
                                        }
                                    </p>

                                    <p>
                                        {
                                            selectedProfile
                                                .profession
                                        }
                                    </p>

                                    <div className="full-profile-location">
                                        <MapPin size={15} />
                                        {
                                            selectedProfile.address
                                        }
                                    </div>

                                </div>

                                <div className="full-profile-match">
                                    <Sparkles size={16} />
                                    92%
                                    <span>Match</span>
                                </div>

                            </div>

                            {/* PERSONAL */}
                            <ProfileSection
                                title="Personal Details"
                            >
                                <ProfileItem
                                    label="Date of Birth"
                                    value={
                                        selectedProfile.dob
                                    }
                                />

                                <ProfileItem
                                    label="Age"
                                    value={`${selectedProfile.age} Years`}
                                />

                                <ProfileItem
                                    label="Height"
                                    value={`${selectedProfile.height} ft`}
                                />

                                <ProfileItem
                                    label="Complexion"
                                    value={
                                        selectedProfile.complexion
                                    }
                                />

                                <ProfileItem
                                    label="Marital Status"
                                    value={
                                        selectedProfile.maritalStatus
                                    }
                                />

                                <ProfileItem
                                    label="Mobile"
                                    value={
                                        selectedProfile.mobile
                                    }
                                />
                            </ProfileSection>

                            {/* EDUCATION */}
                            <ProfileSection
                                title="Education & Career"
                            >
                                <ProfileItem
                                    label="Education"
                                    value={
                                        selectedProfile.education
                                    }
                                />

                                <ProfileItem
                                    label="Profession"
                                    value={
                                        selectedProfile.profession
                                    }
                                />

                                <ProfileItem
                                    label="Company"
                                    value={
                                        selectedProfile.company
                                    }
                                />

                                <ProfileItem
                                    label="Designation"
                                    value={
                                        selectedProfile.designation
                                    }
                                />

                                <ProfileItem
                                    label="Annual Income"
                                    value={
                                        selectedProfile.income
                                    }
                                />
                            </ProfileSection>

                            {/* COMMUNITY */}
                            <ProfileSection
                                title="Community Details"
                            >
                                <ProfileItem
                                    label="Religion"
                                    value={
                                        selectedProfile.religion
                                    }
                                />

                                <ProfileItem
                                    label="Community"
                                    value={
                                        selectedProfile.community
                                    }
                                />

                                <ProfileItem
                                    label="Sub Community"
                                    value={
                                        selectedProfile.subCommunity
                                    }
                                />

                                <ProfileItem
                                    label="Caste"
                                    value={
                                        selectedProfile.caste
                                    }
                                />

                                <ProfileItem
                                    label="Mother Tongue"
                                    value={
                                        selectedProfile.motherTongue
                                    }
                                />
                            </ProfileSection>

                            {/* HOROSCOPE */}
                            <ProfileSection
                                title="Horoscope Details"
                            >
                                <ProfileItem
                                    label="Star / Nakshatra"
                                    value={
                                        selectedProfile.star
                                    }
                                />

                                <ProfileItem
                                    label="Rasi"
                                    value={
                                        selectedProfile.rasi
                                    }
                                />

                                <ProfileItem
                                    label="Dosham"
                                    value={
                                        selectedProfile.dosham
                                    }
                                />
                            </ProfileSection>

                        </div>

                        <div className="full-profile-footer">

                            <div className="remaining-count">

                                <Eye size={15} />

                                {
                                    searchedMember
                                        ?.subscription
                                        ?.profileViews
                                } profile views remaining

                            </div>

                            <button
                                className="footer-download-btn"
                                onClick={() =>
                                    downloadProfile(
                                        selectedProfile
                                    )
                                }
                            >
                                <Download size={17} />
                                Download Profile
                            </button>

                        </div>

                    </div>
                </div>
            )}

            {/* SUBSCRIBE MODAL */}
            {showSubscribeModal && (
                <div
                    className="match-modal-overlay"
                    onClick={() =>
                        setShowSubscribeModal(false)
                    }
                >
                    <div
                        className="subscribe-modal"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        <button
                            className="modal-close-btn"
                            onClick={() =>
                                setShowSubscribeModal(false)
                            }
                        >
                            <X size={20} />
                        </button>

                        <div className="subscribe-icon">
                            <Crown size={30} />
                        </div>

                        <h2>Subscription Required</h2>

                        <p>
                            This member does not have an active
                            membership plan. Please subscribe to
                            a plan to view and download matched
                            profiles.
                        </p>

                        <div className="available-plans">

                            <div>
                                <strong>Basic</strong>
                                <span>Profile Views</span>
                            </div>

                            <div>
                                <strong>Premium</strong>
                                <span>More Profile Views</span>
                            </div>

                            <div>
                                <strong>Gold</strong>
                                <span>Maximum Access</span>
                            </div>

                        </div>

                        <button
                            className="subscribe-plan-btn"
                            onClick={() => {
                                setShowSubscribeModal(false);
                                alert(
                                    "Navigate to Membership Plans"
                                );
                            }}
                        >
                            <CreditCard size={17} />
                            View Membership Plans
                        </button>

                    </div>
                </div>
            )}

            {/* LIMIT MODAL */}
            {showLimitModal && (
                <div
                    className="match-modal-overlay"
                    onClick={() =>
                        setShowLimitModal(false)
                    }
                >
                    <div
                        className="limit-modal"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        <button
                            className="modal-close-btn"
                            onClick={() =>
                                setShowLimitModal(false)
                            }
                        >
                            <X size={20} />
                        </button>

                        <div className="limit-icon">
                            <AlertCircle size={30} />
                        </div>

                        <h2>
                            {limitType === "view"
                                ? "Profile View Limit Reached"
                                : "Profile Download Limit Reached"}
                        </h2>

                        <p>
                            {limitType === "view"
                                ? "You have used all your profile views. Please upgrade your subscription to view more profiles."
                                : "You have used all your profile downloads. Please upgrade your subscription to download more profiles."}
                        </p>

                        <button
                            className="subscribe-plan-btn"
                            onClick={() => {
                                setShowLimitModal(false);
                                alert(
                                    "Navigate to Membership Plans"
                                );
                            }}
                        >
                            <Crown size={17} />
                            Upgrade Plan
                        </button>

                    </div>
                </div>
            )}

        </div>
    );
}

/* =========================
   PROFILE COMPONENTS
========================= */

function ProfileSection({ title, children }) {
    return (
        <div className="profile-section">
            <h3>{title}</h3>

            <div className="profile-section-grid">
                {children}
            </div>
        </div>
    );
}

function ProfileItem({ label, value }) {
    return (
        <div className="profile-item">
            <span>{label}</span>
            <strong>{value || "-"}</strong>
        </div>
    );
}

export default Matches;